class Product360Viewer extends HTMLElement {
  constructor() {
    super();
    this.frames = Array.from(this.querySelectorAll('.product-360__frame'));
    this.stage = this.querySelector('.product-360__stage');
    this.slider = this.querySelector('.product-360__slider');
    this.frameCount = this.frames.length;
    this.currentIndex = 0;
    this.dragging = false;
    this.startX = 0;
    this.startIndex = 0;
    // Roughly one frame swap per this many pixels dragged. Lower = more sensitive.
    this.pxPerFrame = 6;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onSliderInput = this.onSliderInput.bind(this);

    if (this.frameCount > 1 && this.stage) {
      this.stage.addEventListener('pointerdown', this.onPointerDown);
      this.stage.addEventListener('keydown', this.onKeyDown);
      if (this.slider) {
        this.slider.addEventListener('input', this.onSliderInput);
      }
    }
  }

  markInteracted() {
    this.classList.add('has-interacted');
  }

  setFrame(index) {
    const normalized = ((index % this.frameCount) + this.frameCount) % this.frameCount;
    if (normalized === this.currentIndex) return;
    this.frames[this.currentIndex].classList.remove('is-active');
    this.frames[normalized].classList.add('is-active');
    this.currentIndex = normalized;
    if (this.slider) {
      this.slider.value = String(normalized);
    }
  }

  onPointerDown(event) {
    this.dragging = true;
    this.startX = event.clientX;
    this.startIndex = this.currentIndex;
    this.stage.setPointerCapture(event.pointerId);
    this.stage.addEventListener('pointermove', this.onPointerMove);
    this.stage.addEventListener('pointerup', this.onPointerUp);
    this.stage.addEventListener('pointercancel', this.onPointerUp);
    this.markInteracted();
  }

  onPointerMove(event) {
    if (!this.dragging) return;
    const deltaX = event.clientX - this.startX;
    const framesDelta = Math.round(deltaX / this.pxPerFrame) * -1;
    this.setFrame(this.startIndex + framesDelta);
  }

  onPointerUp(event) {
    this.dragging = false;
    this.stage.removeEventListener('pointermove', this.onPointerMove);
    this.stage.removeEventListener('pointerup', this.onPointerUp);
    this.stage.removeEventListener('pointercancel', this.onPointerUp);
    if (this.stage.hasPointerCapture && this.stage.hasPointerCapture(event.pointerId)) {
      this.stage.releasePointerCapture(event.pointerId);
    }
  }

  onKeyDown(event) {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.markInteracted();
      this.setFrame(this.currentIndex + 1);
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.markInteracted();
      this.setFrame(this.currentIndex - 1);
    }
  }

  onSliderInput(event) {
    this.markInteracted();
    this.setFrame(parseInt(event.target.value, 10));
  }
}

if (!customElements.get('product-360-viewer')) {
  customElements.define('product-360-viewer', Product360Viewer);
}
